import { useEffect, useState } from "react";
import { message } from "antd";
import IndoorPositioningHistory from "../../../../api/IndoorPositioningHistory";

const isAbort = (error) =>
  error?.name === "CanceledError" || error?.name === "AbortError";

// Per-subject vitals series for the 生理 tab. Refetches on range / interval /
// subject change; aborts an in-flight request when any of those change again
// before it resolves.
export const useVitalsSeries = (machineID, personnelId, range, intervalS) => {
  const [series, setSeries] = useState([]);
  const [intervalUsed, setIntervalUsed] = useState(intervalS);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!machineID || personnelId == null || !range) {
      setSeries([]);
      return undefined;
    }

    const controller = new AbortController();
    setLoading(true);
    IndoorPositioningHistory.GetVitals(
      machineID,
      personnelId,
      range.startMs,
      range.endMs,
      intervalS,
      controller.signal,
    )
      .then((response) => {
        if (controller.signal.aborted) return;
        if (response.code === 200 && response.data) {
          setSeries(response.data.series || []);
          setIntervalUsed(response.data.intervalUsed);
        } else {
          setSeries([]);
          message.error(response.message || "載入生理數據失敗");
        }
      })
      .catch((error) => {
        if (isAbort(error)) return;
        setSeries([]);
        message.error("載入生理數據失敗");
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, [machineID, personnelId, range?.startMs, range?.endMs, intervalS]);

  return { series, intervalUsed, loading };
};
